import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pre-title" }
const _hoisted_2 = { class: "channel-title" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = {
  key: 0,
  class: "product-price price-input q-my-sm"
}
const _hoisted_5 = {
  class: "computed-price-tag has-tooltip",
  "data-tooltip": `Prices for this channel are managed by a pricing service`
}
const _hoisted_6 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_trash_icon = _resolveComponent("trash-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["channel-product-card", { draft: _ctx.draft, delete: _ctx.pendingRemoval, clickable: _ctx.clickable }]),
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCardClick && _ctx.onCardClick(...args)), ["self"]))
  }, [
    (_ctx.channel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "left",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCardClick && _ctx.onCardClick(...args)))
        }, [
          _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.channel.id), 1),
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.channel.name), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!!_ctx.pricing_manager_service)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.currencySign) + " " + _toDisplayString(_ctx.productPrice), 1)
            ])
          ]))
        : (_openBlock(), _createBlock(_component_q_input, {
            key: 1,
            class: "price-input",
            "model-value": _ctx.productPrice,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:product-price', $event))),
            type: "number",
            mask: "#.##",
            "fill-mask": "0",
            autocomplete: "off",
            "bg-color": "white",
            "hide-bottom-space": "",
            debounce: "100",
            outlined: "",
            "bottom-slots": "",
            dense: ""
          }, {
            prepend: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currencySign), 1)
            ]),
            _: 1
          }, 8, ["model-value"])),
      (!_ctx.pendingRemoval)
        ? (_openBlock(), _createBlock(_component_trash_icon, {
            key: 2,
            class: "trash-icon card-icon",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('remove', _ctx.channelProduct)), ["stop"]))
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}